/**
 * VisionMissionCard Component
 * 
 * A reusable card component for displaying Vision and Mission information.
 * Features hover effects that transition background and text to white.
 * 
 * @param {Object} props
 * @param {string} props.image - Image URL for the card
 * @param {string} props.title - Card title (e.g., "Vision", "Mission")
 * @param {string} props.description - Card description text
 * @param {string} props.delay - Animation delay (e.g., "100ms", "200ms")
 */

import React from 'react';

const VisionMissionCard = ({ image, title, description, delay }) => {
    return (
        <div className="col-xl-6 col-lg-6 wow fadeInUp" data-wow-delay={delay}>
            <div className="delivering-it__single">
                <div className="delivering-it__img">
                    <img
                        src={image}
                        width="500"
                        height="380"
                        style={{ display: "block", objectFit: "cover" }}
                        alt={title}
                    />
                </div>
                <div className="delivering-it__content">
                    <h4 className="delivering-it__content-title">{title}</h4>
                    <p className="delivering-it__content-description">{description}</p>
                </div>
            </div>
        </div>
    );
};

export default VisionMissionCard;
